"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const backendImport_1 = require("@front/backendImport");
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="tutorial-list-page">
    <div class="page-head">
        <div>
            <h1>${() => 'tutorial.list.title'.t()}</h1>
            <p>${() => 'tutorial.list.subtitle'.t()}</p>
        </div>
        <div class="filter-bar">
            <div class="input-group">
                <span class="input-group-text"><i class="simple-icon-magnifier"></i></span>
                <input type="text" 
                       class="form-control" 
                       :value="${x => x.searchQuery}" 
                       @input="${(x, c) => x.onSearchInput(c.event)}" 
                       placeholder="${() => 'tutorial.searchPlaceholder'.t()}">
            </div>
            <select class="form-select" 
                    :value="${x => x.selectedCategory}" 
                    @change="${(x, c) => x.onCategoryChange(c.event)}">
                <option value="">${() => 'tutorial.allCategories'.t()}</option>
                ${(0, fast_element_1.repeat)(x => x.categories, (0, fast_element_1.html) `
                    <option value="${x => x}">${x => x}</option>
                `)}
            </select>
            ${(0, fast_element_1.when)(x => x.canAdd, (0, fast_element_1.html) `
                <button class="btn btn-secondary" @click="${x => x.openCategoryList()}" title="${() => 'tutorial.category.manage'.t()}">
                    <i class="simple-icon-list"></i>
                </button>
                <button class="btn btn-primary" @click="${x => x.openCreateForm()}" title="${() => 'tutorial.create.button'.t()}">
                    <i class="simple-icon-plus"></i>
                </button>
            `)}
        </div>
    </div>

    <div class="tutorial-list-content" ?loading="${x => x.loading}">
        ${x => x.loading ?
    (0, fast_element_1.html) `<div class="loading-spinner">${() => 'common.loading'.t()}</div>` :
    x.filteredData.length > 0 ?
        (0, fast_element_1.html) `<div class="training-grid">
                    ${(0, fast_element_1.repeat)(x => x.filteredData, (0, fast_element_1.html) `
                        <div class="training-card">
                            ${(0, fast_element_1.when)((x, c) => x.draft, (0, fast_element_1.html) `<span class="badge badge-info draft-badge">${() => 'tutorial.draft'.t()}</span>`)}
                            <div class="card-logo">
                                ${x => x.logo ?
            (0, fast_element_1.html) `<img src="${x => ('/uploads/' + x.logo.filename).thumb('tutorial')}" alt="${x => x.name}">` :
            (0, fast_element_1.html) `<div class="tutorial-logo-placeholder"><i class="fa fa-graduation-cap"></i></div>`}
                                <span class="badge-cat">${x => { var _a; return ((_a = x.category) === null || _a === void 0 ? void 0 : _a.name) || 'tutorial.noCategory'.t(); }}</span>
                            </div>
                            <div class="body">
                                <h3>${x => x.name}</h3>
                                ${(0, fast_element_1.when)(x => x._isExpired, (0, fast_element_1.html) `<span class="badge badge-warning expired-badge">${() => 'tutorial.expired'.t()}</span>`)}
                                <p class="desc">${x => x.description || 'tutorial.noDescription'.t()}</p>
                                <div class="meta">
                                    <span><i class="iconsminds-folder"></i> ${x => { var _a; return ((_a = x.tutorialSteps) === null || _a === void 0 ? void 0 : _a.reduce((total, ts) => { var _a; return total + (((_a = ts.tutorialSections) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0)) || 0; }} ${'tutorial.lessons'.t()}</span>
                                </div>
                                <div class="progress">
                                    <div class="progress-bar" style="width: ${x => { var _a; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) || 0; }}%"></div>
                                </div>
                                <div class="small">
                                    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) === 0; }, (0, fast_element_1.html) `<span class="text-muted text-cap">${() => 'tutorial.unstarted'.t()}</span>`)}
                                    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) === 100; }, (0, fast_element_1.html) `<span class="text-success text-semibold"><i class="simple-icon-check"></i> ${() => 'tutorial.done'.t()}</span>`)}
                                    ${(0, fast_element_1.when)(x => { var _a, _b; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) > 0 && ((_b = x._progress) === null || _b === void 0 ? void 0 : _b.percentage) < 100; }, (0, fast_element_1.html) `<span class="text-brand text-semibold">${x => { var _a; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) || 0; }}% ${() => 'tutorial.done'.t()}</span>`)}
                                </div>
                            </div>
                            <div class="foot">
                                <button class="btn btn-primary text-cap flex-grow-1" @click="${(x, c) => c.parent.previewTutorial(x)}">
                                    ${x => console.log(x._progress)}
                                     ${(0, fast_element_1.when)(x => { var _a; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) === 0; }, 'tutorial.start'.t())}
                                    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) === 100; }, 'tutorial.repeat'.t())}
                                    ${(0, fast_element_1.when)(x => { var _a, _b; return ((_a = x._progress) === null || _a === void 0 ? void 0 : _a.percentage) > 0 && ((_b = x._progress) === null || _b === void 0 ? void 0 : _b.percentage) < 100; }, 'tutorial.continue'.t())}
                                    <i class="simple-icon-arrow-right-circle"></i>
                                </button>
                                ${(0, fast_element_1.when)((x, c) => c.parent.canEdit(x), (0, fast_element_1.html) `
                                    <button class="btn btn-outline-secondary" @click="${(x, c) => c.parent.editTutorial(x)}" title="${() => 'crud.edit'.t()}">
                                        <i class="simple-icon-pencil"></i>
                                    </button>
                                `)}
                                ${(0, fast_element_1.when)((x, c) => c.parent.canDelete(x), (0, fast_element_1.html) `
                                    <button class="btn btn-outline-danger" @click="${(x, c) => c.parent.deleteTutorial(x)}" title="${() => 'crud.delete'.t()}">
                                        <i class="simple-icon-trash"></i>
                                    </button>
                                `)}
                            </div>
                        </div>
                    `)}
                </div>` :
        (0, fast_element_1.html) `<div class="empty-state">
                    <i class="fa fa-graduation-cap"></i>
                    <h3>${() => 'tutorial.list.empty.title'.t()}</h3>
                    <p>${() => 'tutorial.list.empty.message'.t()}</p>
                    ${(0, fast_element_1.when)(x => x.canAdd, (0, fast_element_1.html) `
                        <button class="btn btn-primary" @click="${x => x.openCreateForm()}">
                            ${() => 'tutorial.create.button'.t()}
                        </button>
                    `)}
                </div>`}
    </div>

    <rws-crud-pagination
        :currentPage="${x => x.currentPage}"
        :totalPages="${x => x.totalPages}" 
        :perPage="${x => x.perPage}"
        @page-change="${(x, c) => x.handlePageChange(c.event.detail)}"
    ></rws-crud-pagination>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.tutorial-list-page {
  padding: 24px;
}
.tutorial-list-page .page-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 24px;
}
.tutorial-list-page .page-head h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: var(--color-text-primary);
}
.tutorial-list-page .page-head p {
  color: var(--color-text-secondary);
  margin: 0;
}
.tutorial-list-page .filter-bar {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  flex: 1 1 340px;
  max-width: 460px;
}
.tutorial-list-page .filter-bar .input-group {
  flex-grow: 1;
}
.tutorial-list-page .filter-bar .input-group .input-group-text {
  background: #fff;
  border-color: var(--chat_header_color);
  color: var(--color-text-secondary);
  border-radius: 0.375rem 0 0 0.375rem;
}
.tutorial-list-page .filter-bar .form-control,
.tutorial-list-page .filter-bar .form-select {
  border-color: var(--chat_header_color);
}
.tutorial-list-page .filter-bar .form-control {
  border-left: 0;
  border-radius: 0 0.375rem 0.375rem 0;
}
.tutorial-list-page .filter-bar .form-control:focus,
.tutorial-list-page .filter-bar .form-select:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 0.2rem rgba(var(--color-primary-rgb, 0, 123, 255), 0.2);
}
.tutorial-list-page .filter-bar .btn-brand {
  flex-shrink: 0;
}
@media (max-width: 575px) {
  .tutorial-list-page .filter-bar {
    max-width: none;
    flex-wrap: wrap;
  }
}
.tutorial-list-page .tutorial-list-content {
  min-height: 300px;
}
.tutorial-list-page .tutorial-list-content[loading] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tutorial-list-page .training-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 22px;
  margin-bottom: 24px;
}
.tutorial-list-page .training-card {
  background: #fff;
  border: 1px solid var(--chat_header_color);
  border-radius: var(--border-radius-lg, 14px);
  overflow: hidden;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.tutorial-list-page .training-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px -22px rgba(31, 44, 85, 0.4);
}
.tutorial-list-page .training-card .card-logo {
  position: relative;
  height: 120px;
  display: grid;
  place-items: center;
  background: #fff;
  border-bottom: 1px solid var(--chat_header_color);
}
.tutorial-list-page .training-card .card-logo img {
  max-height: 44px;
  width: auto;
}
.tutorial-list-page .training-card .card-logo .tutorial-logo-placeholder {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary-light);
  color: var(--color-primary);
  font-size: 28px;
  border-radius: 50%;
}
.tutorial-list-page .training-card .badge-cat {
  position: absolute;
  top: 12px;
  right: 12px;
  background: var(--color-primary-light);
  color: var(--color-primary-dark, var(--color-primary));
  border: 1px solid var(--color-primary);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 2px 9px;
  border-radius: 999px;
}
.tutorial-list-page .training-card .body {
  padding: 16px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.tutorial-list-page .training-card .body .expired-badge {
  align-self: flex-start;
}
.tutorial-list-page .training-card .body h3 {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0;
  color: var(--color-text-primary);
}
.tutorial-list-page .training-card .body .desc {
  color: var(--color-text-secondary);
  font-size: 0.86rem;
  flex: 1;
  margin: 0;
}
.tutorial-list-page .training-card .body .meta {
  display: flex;
  align-items: center;
  gap: 14px;
  color: var(--color-text-secondary);
  font-size: 0.8rem;
}
.tutorial-list-page .training-card .body .meta i {
  color: var(--color-primary);
}
.tutorial-list-page .training-card .body .progress {
  height: 8px;
  background: var(--color-primary-light);
  border-radius: 4px;
  margin-top: 4px;
}
.tutorial-list-page .training-card .body .progress .progress-bar {
  background: var(--color-primary);
}
.tutorial-list-page .training-card .foot {
  padding: 0 18px 18px;
  display: flex;
  gap: 8px;
}
.tutorial-list-page .training-card .foot .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.tutorial-list-page .empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--color-text-secondary);
}
.tutorial-list-page .empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
  color: var(--color-primary);
}
.tutorial-list-page .empty-state h3 {
  margin: 0 0 8px 0;
  color: var(--color-text-primary);
}
.tutorial-list-page .empty-state p {
  margin: 0 0 24px 0;
}
.tutorial-list-page .loading-spinner {
  text-align: center;
  padding: 40px;
  color: var(--color-text-secondary);
}

.text-semibold {
  font-weight: 600;
}

.text-cap {
  text-transform: capitalize;
}

.draft-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 5;
}`;
const shadowOptions = { "mode": "open" };
let TutorialList = class TutorialList extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.data = [];
        this.loading = false;
        this.currentPage = 1;
        this.totalPages = 1;
        this.perPage = 10;
        this.canAdd = false;
        this.canEditGlobal = false;
        this.canDeleteGlobal = false;
        this.searchQuery = '';
        this.selectedCategory = '';
        this.categories = [];
    }
    async connectedCallback() {
        var _a;
        // Set up global permissions
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) !== backendImport_1.UserRoles.USER;
        this.canAdd = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.write}`, component_2.DefaultLayout.USER.acl);
        this.canEditGlobal = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.write}`, component_2.DefaultLayout.USER.acl);
        this.canDeleteGlobal = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.delete}`, component_2.DefaultLayout.USER.acl);
        console.log('isSuperAdmin:', isSuperAdmin, 'canAdd:', this.canAdd, 'canEditGlobal:', this.canEditGlobal, 'canDeleteGlobal:', this.canDeleteGlobal);
        super.connectedCallback();
        await this.loadData();
    }
    async loadData() {
        try {
            this.loading = true;
            let routeOptions = {};
            if (this.currentPage > 1) {
                routeOptions.queryParams = {
                    p: this.currentPage.toString(),
                    per_page: this.perPage.toString()
                };
            }
            const response = await this.apiService.back.get('tutorial.list', routeOptions);
            if (response && response.success && Array.isArray(response.data)) {
                this.data = response.data;
                this.totalPages = Math.max(1, Math.ceil(response.count / this.perPage));
                this.categories = [...new Set(this.data.map((t) => t.category).filter((c) => c && typeof c === 'string'))];
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'tutorial.loadListFailed'.t());
            }
        }
        catch (error) {
            console.error('Failed to load tutorials:', error);
            this.popupService.error('tutorial.loadListFailed'.t());
        }
        finally {
            this.loading = false;
        }
    }
    async deleteTutorial(tutorial) {
        const confirmed = await this.popupService.confirm('tutorial.delete.confirmText'.t(), false, 'tutorial.delete.confirm'.t());
        if (confirmed) {
            try {
                const response = await this.apiService.back.delete('tutorial.delete', {
                    routeParams: { id: tutorial.id }
                });
                if (response.success) {
                    this.notifyService.notify('tutorial.delete.success'.t());
                    await this.loadData();
                }
                else {
                    this.popupService.error(response.error || 'tutorial.deleteFailed'.t());
                }
            }
            catch (error) {
                console.error('Failed to delete tutorial:', error);
                this.popupService.error('tutorial.deleteFailed'.t());
            }
        }
    }
    openCreateForm() {
        component_1.SiteMenu.goto.bind(this)('/tutorial/create');
    }
    openCategoryList() {
        component_1.SiteMenu.goto.bind(this)('/tutorial/category/list');
    }
    editTutorial(tutorial) {
        component_1.SiteMenu.goto.bind(this)(`/tutorial/edit/${tutorial.id}`);
    }
    previewTutorial(tutorial) {
        component_1.SiteMenu.goto.bind(this)(`/tutorial/preview/${tutorial.id}`);
    }
    handlePageChange(event) {
        this.currentPage = event.detail;
        this.loadData();
    }
    canEdit(tutorial) {
        var _a;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        if (isSuperAdmin)
            return true;
        // Always allow creators to edit their tutorials
        if (this.isUserOwnerOrCreator(tutorial))
            return true;
        // Otherwise check global permission
        return this.canEditGlobal;
    }
    canDelete(tutorial) {
        var _a;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        if (isSuperAdmin)
            return true;
        // Always allow creators to delete their tutorials
        if (this.isUserOwnerOrCreator(tutorial))
            return true;
        // Otherwise check global permission
        return this.canDeleteGlobal;
    }
    isUserOwnerOrCreator(tutorial) {
        var _a;
        const currentUserId = component_2.DefaultLayout.USER.id;
        const tutorialOwnerId = tutorial.owner ? tutorial.owner : null;
        const tutorialCreatorId = ((_a = tutorial.creator) === null || _a === void 0 ? void 0 : _a.id) ? tutorial.creator.id : null;
        return tutorialOwnerId === currentUserId || tutorialCreatorId === currentUserId;
    }
    get filteredData() {
        let result = this.data || [];
        if (this.searchQuery.trim()) {
            const query = this.searchQuery.toLowerCase();
            result = result.filter((t) => (t.name && t.name.toLowerCase().includes(query)) ||
                (t.description && t.description.toLowerCase().includes(query)));
        }
        if (this.selectedCategory) {
            result = result.filter((t) => t.category === this.selectedCategory);
        }
        return result;
    }
    onSearchInput(event) {
        this.searchQuery = event.target.value;
    }
    onCategoryChange(event) {
        this.selectedCategory = event.target.value;
    }
};
exports.TutorialList = TutorialList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialList.prototype, "data", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "perPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "canAdd", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "canEditGlobal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "canDeleteGlobal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialList.prototype, "selectedCategory", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialList.prototype, "categories", void 0);
exports.TutorialList = TutorialList = __decorate([
    (0, client_1.RWSView)('tutorial-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], TutorialList);
TutorialList.defineComponent();
